require('./blocks/digest/digest');
require('./blocks/brochure.less');
require('./blocks/brochure-slider/brochure-slider');
require('./blocks/news/news');
require('./blocks/rating-stars/rating-stars');
require('./blocks/video-item.less');
require('./blocks/seminar.less');
require('./blocks/seo-catalog.less');

require('./plugins/jquery.loader/require.js');
require('./blocks/seminars-video/seminars-video');



// WEBPACK FOOTER //
// ./training_materials.js